import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { useFulfillmentPlanIdContext } from '../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useEntitiesFulfillmentPlanProperty } from '../../../../../hooks/entities/selectors/fulfillment-plans';
import OrderDetailsFulfillmentDisplaySection from '../../../fulfillment/section';
import FulfillmentDisplayContent from './fulfillment-display-content';

const FulfillmentDisplay = ({ fulfillmentId }) => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const fulfillmentType = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, 'fulfillmentType');

  return (
    <OrderDetailsFulfillmentDisplaySection>
      <FulfillmentDisplayContent fulfillmentId={fulfillmentId} fulfillmentPlanId={fulfillmentPlanId} fulfillmentType={fulfillmentType} />
    </OrderDetailsFulfillmentDisplaySection>
  );
};

FulfillmentDisplay.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export default memo(FulfillmentDisplay);
